"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var WaterBottle = function WaterBottle(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.25,3.875V2.25a1.5,1.5,0,0,0-1.5-1.5h-1.5a1.5,1.5,0,0,0-1.5,1.5V3.875",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.939,3.75A5.689,5.689,0,0,0,5.25,9.439a.751.751,0,0,0,.22.531l.75.75a.749.749,0,0,1,0,1.06l-.75.75a.751.751,0,0,0-.22.531v2.378a.751.751,0,0,0,.22.531l.75.75a.749.749,0,0,1,0,1.06l-.75.75a.751.751,0,0,0-.22.531V21.75a1.5,1.5,0,0,0,1.5,1.5h10.5a1.5,1.5,0,0,0,1.5-1.5V19.061a.751.751,0,0,0-.22-.531l-.75-.75a.749.749,0,0,1,0-1.06l.75-.75a.751.751,0,0,0,.22-.531V13.061a.751.751,0,0,0-.22-.531l-.75-.75a.749.749,0,0,1,0-1.06l.75-.75a.751.751,0,0,0,.22-.531A5.689,5.689,0,0,0,13.061,3.75Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.439 11.25L17.561 11.25",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.439 17.25L17.561 17.25",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }));
};
WaterBottle.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
WaterBottle.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = WaterBottle;